import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PersonIcon from '@mui/icons-material/Person';
import { Box, Link, styled, Typography } from '@mui/material';
import { Avatar } from '../avatar';
import { TypographyTruncate } from '../typography-truncate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var LinkIcon = styled(PersonIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.palette.primary.main;
}, function (props) {
  return props.theme.palette.primary.dark;
});
var StyledAvatar = styled(Avatar)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.spacing(1);
}, function (props) {
  return props.theme.spacing(5);
});

var Option = function Option(_ref) {
  var member = _ref.member,
      hasCorporateAccess = _ref.hasCorporateAccess;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        width: {
          xs: '88%',
          sm: '100%',
          lg: '88% '
        }
      },
      "data-element": "Box",
      "data-component": "Option",
      "data-source-file": "option.tsx",
      children: [/*#__PURE__*/_jsx(StyledAvatar, {
        member: _objectSpread(_objectSpread({}, member), {}, {
          id: member.uuid,
          avatarUrl: member.image
        }),
        disabledPopover: true,
        "data-element": "StyledAvatar",
        "data-component": "Option",
        "data-source-file": "option.tsx"
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          mx: 2,
          width: '70%'
        },
        "data-element": "Box",
        "data-source-file": "option.tsx",
        children: [/*#__PURE__*/_jsx(TypographyTruncate, {
          lines: 1,
          variant: "h4",
          fontWeight: "fontWeightBold",
          "data-element": "TypographyTruncate",
          "data-source-file": "option.tsx",
          children: member.name
        }), /*#__PURE__*/_jsx(TypographyTruncate, {
          variant: "body2",
          lines: 1,
          "data-element": "TypographyTruncate",
          "data-source-file": "option.tsx",
          children: member.email
        }), member.title && /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          children: member.title
        }), member.company && /*#__PURE__*/_jsx(Typography, {
          variant: "body2",
          children: member.company
        })]
      })]
    }), hasCorporateAccess && /*#__PURE__*/_jsx(Link, {
      href: "/corporate/contacts/".concat(member.uuid),
      onClick: function onClick(event) {
        return event.stopPropagation();
      },
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsx(LinkIcon, {
        fontSize: "large"
      })
    })]
  });
};

export default Option;